import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, HTTP_INTERCEPTORS, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { ErrorLoggingService } from './shared/services/errorLogging.service';
import { SpinnerInterceptor } from './shared/interceptors/spinner.interceptor';
import { HttpErrorInterceptor } from './shared/interceptors/http-error.interceptor';

import { provideMSAL, MSALInstanceFactory, MSALGuardConfigurationFactory, MSALInterceptorConfigFactory } from './shared/msal/msal.config';
import { MsalService, MsalBroadcastService, MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { InitService } from './core/services/init.service';
 
// Ensure MSAL initializes before usage
function initializeMsal(msalService: MsalService) {  
  return () => msalService.instance.initialize();
}
export function initializeApp(initService: InitService) {
  return () => initService.initializeApp();
}
 
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideLottieOptions({
      player: () => player,
    }),
    provideHttpClient(withInterceptors([HttpErrorInterceptor, SpinnerInterceptor,AuthInterceptor])),
    ErrorLoggingService,
    provideMSAL(MSALInstanceFactory, MSALGuardConfigurationFactory, MSALInterceptorConfigFactory),
    MsalGuard,
    MsalService,
    MsalBroadcastService,
    // Ensure MSAL initializes before being used
    {
      provide: APP_INITIALIZER,
      useFactory: initializeMsal,
      deps: [MsalService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [InitService],
      multi: true,
    }
  ],
};